import { message } from 'antd';
import { notifyError } from './notification';

export const scrollUp = (position, fallbackMessage?) => {
	if (window.scrollTo)
		window.scrollTo({
			top: position,
			behavior: 'smooth'
		});
	else notifyError(fallbackMessage);
};
